import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Grid } from '@mui/material';
import TopNavBar from '../user/top_nav_bar';
import PopupTitle from '../common/popup_title';
import MealBasketWidget from '../../features/end_user_shopping/components/meal_basket_widget';
import RecipesEndUserGRCRecipeItem from './recipes_end_user_grc_recipe_item';
import NarrowEndUserMoreButton from '../meal/narrow_end_user_more_button';
import {
  useGetGRCRecipeCategoriesQuery,
  useGetGRCResultQuery,
} from '../../app/smorgAppSyncGraphQLApi';
import { useGetEndUserSpaceQuery } from '../../app/smorgAppSyncGraphQLApiCustomHooks';

const RecipesEndUserGRCRecipeCategoryView = () => {
  const navigate = useNavigate();

  const [offset, setOffset] = useState(0);

  const [isLoadingMore] = useState(false);

  const { categoryID } = useParams();

  const { data: currentSpace } = useGetEndUserSpaceQuery();

  const { data: grcRecipeCategories } = useGetGRCRecipeCategoriesQuery(
    currentSpace?.id,
    {
      skip: !currentSpace?.id,
    },
  );

  const { data: grcResult } = useGetGRCResultQuery(
    { spaceID: currentSpace?.id, grcRecipeCategoryID: categoryID, offset },
    {
      skip: !currentSpace?.id || !categoryID,
    },
  );

  const grcRecipeCategory = grcRecipeCategories.find(
    (c) => c.id === categoryID,
  );

  const title = grcRecipeCategory?.title;

  const grcRecipeIDs = (grcResult?.data || []).map((item) => item.grcRecipeID);

  const moreAvailable = grcResult?.moreAvailable;

  const onLoadMore = setOffset(grcResult?.nextOffset);

  const onClickBack = () => navigate(-1);

  return (
    <div className="recipes-view">
      <TopNavBar />
      <MealBasketWidget />
      <div
        className="topNavBarMobile topNavBarMobileLight"
        style={{
          color: 'var(--app-primary-font-color)',
          height: '70px',
          flexDirection: 'column',
        }}>
        <PopupTitle
          titleText={title}
          backButtonEnabled
          onClickBack={onClickBack}
        />
      </div>
      <div>
        <Grid container style={{ paddingLeft: '15px' }}>
          {grcRecipeIDs.map((grcRecipeID) => (
            <Grid
              item
              xs={12}
              md={6}
              lg={4}
              key={grcRecipeID}
              style={{ flexShrink: 0 }}>
              <RecipesEndUserGRCRecipeItem
                grcRecipeID={grcRecipeID}
                favouriteEnabled
                copyEnabled
                isFullWidth
              />
            </Grid>
          ))}
        </Grid>
        {isLoadingMore && (
          <Grid
            item
            xs={6}
            sm={4}
            md={3}
            lg={2}
            style={{ color: 'var(--app-primary-font-color)' }}>
            <NarrowEndUserMoreButton isLoading onClick={() => {}} />
          </Grid>
        )}
        {!isLoadingMore && moreAvailable && (
          <Grid item xs={6} sm={4} md={3} lg={2}>
            <NarrowEndUserMoreButton onClick={onLoadMore} />
          </Grid>
        )}
      </div>
    </div>
  );
};

export default RecipesEndUserGRCRecipeCategoryView;
